module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n        Progress ใช้สำหรับแสดงปริมาณการกำเนินการ\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentMessage'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Message\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentTooltip'
      }
    }
  }, [_vm._v("\n            Tooltip   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-progress"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Progress\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Progress ใช้งาน Class "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-progress")]), _vm._v("\n        บน Element "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<progress>")]), _vm._v(" เพียงอย่างเดียว\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-progress")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Color: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-primary")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-accent")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-positive")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-negative")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-warning")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-info")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-dark")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-black")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Progress -->\n<progress class=\"bio-progress -primary\" value=\"10\" max=\"100\"></progress>\n<progress class=\"bio-progress -accent\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress -positive\" value=\"30\" max=\"100\"></progress>\n<progress class=\"bio-progress -negative\" value=\"40\" max=\"100\"></progress>\n<progress class=\"bio-progress -warning\" value=\"50\" max=\"100\"></progress>\n<progress class=\"bio-progress -info\" value=\"60\" max=\"100\"></progress>\n<progress class=\"bio-progress -dark\" value=\"70\" max=\"100\"></progress>\n<progress class=\"bio-progress -black\" value=\"80\" max=\"100\"></progress>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('progress', {
    staticClass: "bio-progress -primary _mgbt-8px",
    attrs: {
      "value": "10",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -accent _mgbt-8px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -positive _mgbt-8px",
    attrs: {
      "value": "30",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -negative _mgbt-8px",
    attrs: {
      "value": "40",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -warning _mgbt-8px",
    attrs: {
      "value": "50",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -info _mgbt-8px",
    attrs: {
      "value": "60",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -dark _mgbt-8px",
    attrs: {
      "value": "70",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -black",
    attrs: {
      "value": "80",
      "max": "100"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน รูปแบบอื่น")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<progress class=\"bio-progress _h-1px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-2px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-4px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-8px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-16px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-32px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-64px\" value=\"20\" max=\"100\"></progress>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-1px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-2px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-4px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-8px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-16px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-32px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _h-64px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c98770c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/ComponentProgress.vue
// module id = 135
// module chunks = 0